/* eslint-disable react/prop-types */
import React from 'react';

export const Delete = ({ fontSize = 24, ...props }) => (
  <svg
    width={fontSize}
    height={fontSize}
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.02937 8.7989C5.44248 8.76872 5.80184 9.07914 5.83202 9.49226L6.44398 17.8679C6.54188 19.2098 7.65946 20.2489 9.00381 20.2489H14.9969C16.3422 20.2489 17.4588 19.2099 17.5567 17.8689L18.1686 9.49226C18.1988 9.07915 18.5582 8.76872 18.9713 8.7989C19.3844 8.82908 19.6948 9.18844 19.6647 9.60155L19.0527 17.9781C18.8976 20.1026 17.1286 21.7489 14.9969 21.7489H9.00381C6.87301 21.7489 5.10306 20.1027 4.94796 17.9772L4.33601 9.60156C4.30583 9.18845 4.61625 8.82909 5.02937 8.7989Z"
      fill="#BE2929"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.98535 6.40234C2.98535 5.98813 3.32114 5.65234 3.73535 5.65234H20.2649C20.6791 5.65234 21.0149 5.98813 21.0149 6.40234C21.0149 6.81656 20.6791 7.15234 20.2649 7.15234H3.73535C3.32114 7.15234 2.98535 6.81656 2.98535 6.40234Z"
      fill="#BE2929"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.94308 2.25001H14.0631C14.9665 2.25001 15.7593 2.85718 15.9931 3.7315C15.997 3.7462 16.0005 3.76101 16.0035 3.77592L16.5065 6.25194C16.589 6.65787 16.3268 7.05378 15.9208 7.13624C15.5149 7.2187 15.119 6.95648 15.0365 6.55056L14.5391 4.10196C14.4755 3.89382 14.2824 3.75001 14.0631 3.75001H9.93937C9.71814 3.74925 9.52454 3.89289 9.4602 4.10175L8.96784 6.54917C8.88614 6.95525 8.49072 7.21821 8.08465 7.13652C7.67857 7.05483 7.4156 6.65941 7.4973 6.25333L7.99542 3.77731C7.99855 3.76174 8.00218 3.74628 8.00629 3.73094C8.2414 2.85436 9.03674 2.24754 9.94308 2.25001Z"
      fill="#BE2929"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1016 11.0312C10.5158 11.0312 10.8516 11.367 10.8516 11.7812V16.2896C10.8516 16.7039 10.5158 17.0396 10.1016 17.0396C9.68735 17.0396 9.35156 16.7039 9.35156 16.2896V11.7812C9.35156 11.367 9.68735 11.0312 10.1016 11.0312ZM13.482 11.0312C13.8962 11.0312 14.232 11.367 14.232 11.7812V16.2896C14.232 16.7039 13.8962 17.0396 13.482 17.0396C13.0678 17.0396 12.732 16.7039 12.732 16.2896V11.7812C12.732 11.367 13.0678 11.0312 13.482 11.0312Z"
      fill="#BE2929"
    />
  </svg>
);
